import httpClient from "@/plugins/axios";

export const getWallpapers = async (categoryId = null) => {
    const params = categoryId ? { category: categoryId } : {};
    const response = await httpClient.get(`/admin/v1/wallpapers/`, { params });
    return response;
}

export const saveWallpaper = async (image, categoryId = null) => {
    const data = new FormData();
    data.append('image', image);
    if (categoryId) {
        data.append('category', categoryId);
    }
    const response = await httpClient.post(`/admin/v1/wallpapers/`, data);
    return response;
}

export const deleteWallpaper = async (id) => {
    const response = await httpClient.delete(`/admin/v1/wallpapers/${id}/`);
    return response;
}

export const sortWallpapers = async (sortedIds) => {
    let query = "?order=" + sortedIds.join("&order=");
    const response = await httpClient.post(`/admin/v1/wallpapers/sort/${query}`)
    return response;
}
